import React from "react";

const SummaryCardEl = ({
  setStatusFocused,
  statusFocused,
  status_id,
  data,
  title,
  qtyClassStyle,
  setFilterList,
  setInternFilterTypeList,
  qtyColorText,
  cardWidth,
  cardHeight,
  percentage,
}) => {
  const styles = {
    container: {
      backgroundColor: statusFocused == status_id ? "#e7f3ff" : "",
      width: cardWidth ?? "",
      height: cardHeight ? cardHeight : "130px",
      border: statusFocused == status_id ? "2px solid #0d6efd" : "1px solid #ccc",
      boxShadow: statusFocused == status_id ? "0 4px 12px rgba(13, 110, 253, 0.3)" : "",
    },
    qtyStyle: {
      color: qtyColorText ? qtyColorText : "",
    },
  };

  return (
    <div
      className="col"
      type="button"
      onClick={() => {
        setStatusFocused(status_id);
        setFilterList(data);
        setInternFilterTypeList(data);
      }}
    >
      <div className="card shadow" style={styles.container}>
        <div className="card-body">
          <div className={`display-3`} style={styles.qtyStyle}>
            {data.length}
          </div>
          <div className="d-flex align-items-center justify-content-between">
            {percentage && (
              <div className="h5 text-success mb-0">
                {percentage}%
              </div>
            )}
            <div className="flex-grow-1 ms-2">
              <span class="badge badge-soft-dark"> {title}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCardEl;
